import { render, staticRenderFns } from "./yiyuanjieshao.vue?vue&type=template&id=2a4bae3a&scoped=true"
import script from "./yiyuanjieshao.vue?vue&type=script&lang=js"
export * from "./yiyuanjieshao.vue?vue&type=script&lang=js"
import style0 from "./yiyuanjieshao.vue?vue&type=style&index=0&id=2a4bae3a&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bae3a",
  null
  
)

export default component.exports